import { Button, Icon, Popover, Row } from "antd";
import React, { useState, useEffect } from "react";
import { getMaterial } from "../../../api/courses";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Generals/Loading";
import { ACT_FINAL, ACT_VALORACION } from "../../../utils/constanst";
import MainMaterial from "./MainMaterial";
import { setBlock } from "../../../redux/actions/entity";
import img1 from "../../../assets/img/AI/Lec1.png"
import img2 from "../../../assets/img/AI/Lec2.png"
import img3 from "../../../assets/img/AI/Lec3.png"
import img4 from "../../../assets/img/AI/Lec4.png"
import img5 from "../../../assets/img/AI/Lec5.png"
import img6 from "../../../assets/img/AI/Lec6.png"
import img7 from "../../../assets/img/AI/Lec7.png"
import img8 from "../../../assets/img/AI/Lec8.png"
//import ReactPlayer from "react-player";
//import Viewers from "../../Generals/Viewer";
import { capitalizeWord } from "../../Generals/functions";

/**
 * Componente que muestra los material de acuerdo a la lección y a la entidad.
 * @param {*} array- lecciones
 */
export default function Material({ lesson, setLoading }) {
  const { idLeccion } = lesson;
  //Hook para almacenar la lista de materiales
  const [material, setMaterial] = useState({ loading: false, data: [] });
  //Se obtiene el idEntidad seleccionada del store de redux
  const { idEntidad } = useSelector((state) => state.entidad);
  const entidad  = useSelector((state) => state.entidad);
  const { loading, data } = material; // Destructuring del hook-materiales
  const dispatch = useDispatch();

  useEffect(() => {
    if (idLeccion && idLeccion !== ACT_FINAL && idLeccion !== ACT_VALORACION) {
      // console.log("Peticion", idLeccion);
      window.scrollTo(0, 0); // para posicionar el scroll al inicio
      setMaterial({ loading: true, data: [] }); //Se muestra el loading de cargando
      dispatch(setBlock(true));
      //Se hace la petición para obtener los materiales
      getMaterial(idEntidad, idLeccion)
        .then((res) => {
          setMaterial({ loading: false, data: res.data.material });
          dispatch(setBlock(false));
        })
        .catch((e) => {
          setMaterial({ loading: false, data: [] });
          dispatch(setBlock(true));
          console.log("Error Materiales", e);
        });
    } else {
      setMaterial({ data: [] });
      dispatch(setBlock(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEntidad, idLeccion]);

  const Text = ({ idLesson }) => {
    if (idLesson !== ACT_FINAL && idLesson !== ACT_VALORACION) {
      return (
        <>
          <h2 className="subtitlesLesons">CONTENIDO DE LA LECCIÓN</h2>
        </>
      );
    }
    return null;
  };
  /*Se utiliza el método para que se interpreten los tags html que se insertaron en los textos en la BD y para sustituir las variables
  por los textos correspondientes a la entidad*/
  const getTextHTML= (texto) => {
    const entidadesSinPartido = [9]
    const fraseReplace = new RegExp(" o sin partido", "g");
    //Se condicionan la entidad de EDOMEX ya que los artículos "el, del," varían a traves del documento
    const textoCompleto = idEntidad === 15 && idLeccion === 2
      ? texto.replace("de #ENTIDAD#", capitalizeWord(entidad.entidad).replace('el', 'del'))
      : entidadesSinPartido.includes(idEntidad) 
        ? texto.replace("#ENTIDAD#",capitalizeWord(entidad.entidad))
        : texto.replace("#ENTIDAD#",capitalizeWord(entidad.entidad)).replace(fraseReplace, '')
    return (
      <span  dangerouslySetInnerHTML={{__html:textoCompleto }}></span>)
  };

  const getImgAI = (idLeccion) => {
    let imagen = null;
    switch (idLeccion) {
      case 1:
        imagen = img1;
        break;
      case 2:
        imagen = img2;
        break; 
      case 3:
        imagen = img3;
        break; 
      case 4:
        imagen = img4;
        break;
      case 5:
        imagen = img5;
        break;
      case 6:
        imagen = img6;
        break;
      case 7:
        imagen = img7;
        break;
      case 8:
        imagen = img8;
        break;
      default:
        break;
    }

    return imagen
  }

  return (
    <div>
      {idLeccion !== ACT_FINAL && idLeccion !== ACT_VALORACION ? (
        <>
          <Row style={{textAlign: "center"}}>
            <img alt= "Imagen" src={getImgAI(idLeccion)} style={{maxHeight:"450px"}}/>
          </Row>
          <h2 className="subtitlesLesons">OBJETIVO DE APRENDIZAJE</h2>
          <p className="texto_parrafo">{getTextHTML(lesson.objetivo)}</p>
          <h2 className="subtitlesLesons">INTRODUCCIÓN</h2>
          {/*En la base de datos se agrega el texto #ENTIDAD# y aqui se reemplaza por el nombre de la entidad */ }
          <p className="texto_parrafo">{getTextHTML(lesson.introduccion)}</p>
          <Text idLesson={idLeccion} />
          {loading ? (
            <Loading />
          ) : (
            data && data.length && (
              <MainMaterial
                idLesson={idLeccion} //Se manda la lección
                data={data} //EL material
                setLoading={setLoading} //El loading para bloquear la pantalla
              />
            )
          )}
        </>
      ) : (
        <>
          <p>{getTextHTML(lesson.introduccion)}</p>
          {idLeccion === ACT_VALORACION && <p style={{textAlign: "right"}}><b>¡Gracias por tu colaboración!</b></p>}
        </>
      )}
    </div>
  );
}

/**
 * Componente que muestra material de la lección
 * @param {*} doc - Material
 */
export const RenderDocument = ({ doc, tipo, number, getNumber}) => {
  switch (doc.tipoMaterial) {
    case 1:
      return <RenderVideo file={doc} />;
    case 2:
      return <RenderLinkPDF file={doc} tipo={tipo} />;
    case 3:
      return <RenderLinkImg file={doc} />;
    case 4:
      return <RenderLinkPowerP file={doc} />;
    case 5:
      return <RenderLinkExterno file={doc} />;
    default:
      return <RenderOther file={doc} number={number} getNumber={getNumber} />;
  }
};

/**
 * Componente que muestra el material embebido si es tipo video Se utilizó en el PEL2023.
 * @param {*} document- Material
 */
export const RenderVideo = ({ file }) => {
  return (
    <>
      {/* <MatApoyo array={[{ material: file.material }]} /> */}
      <div className="matTitle">Material de apoyo</div>
      <p className="matApoyo" style={{ textAlign: "left" }}>
        {file.material}
      </p>
      <iframe
        title={file.idMaterial}
        src={file?.url}
        width="100%"
        height="500"
        style={{ border: "none", overflow: "hidden"}}
      />

      {/*Se repoducen los videos con la librería ReactPlayer*/}
      {/* <ReactPlayer className="video" url={file?.url} controls /> */}
    </>
  );
};

/**
 * Componente que muestra un link a un recurso externo (Videos, material interactivo sitios web).
 * @param {*} document- Material
 */
export const RenderLinkExterno = ({ file }) => {
  return (
    <>
      <a
        className="matApoyoLink"
        href={file.url}
        target="_blank"
        rel="noopener noreferrer"
      >

        {file.material}
      </a>

      {/*Se repoducen los videos con la librería ReactPlayer*/}
      {/* <ReactPlayer className="video" url={file?.url} controls /> */}
    </>
  );
};
/**
 * Componente que muestra el material si es tipo imagen en un visor Se utilizó en el PEL2023.
 * @param {*} document- Material
 */
//const RenderImg = ({ file }) => {
//  const image = [{ src: `data:image/jpeg;base64,${file.url}` }];
//  const { modal } = useSelector((state) => state.modal); //Se obtiene el valor del store-Redux
//  return (
//    <>
//      <div className="matTitle">Material de apoyo</div>
//      <span className="matApoyo">{file.material}</span>
//      {/* Componente para mostrar las imagen en el Viewer */}
//      <div style={modal ? { pointerEvents: "none", opacity: "0.4" } : {}}>
//        <div id={file.idMaterial} className="visorImage" />
//        <Viewers container={file.idMaterial} image={image} />
//      </div>
//
//      {/* <img
//        src={`data:image/jpeg;base64,${file.url}`}
//        alt={file.idMaterial}
//        className="imgMaterial"
//      /> */}
//    </>
//  );
//};

const RenderLinkImg = ({ file }) => {
  const image = { src: `data:image/jpeg;base64,${file.url}` };
  return (
     <Popover 
      content={<img src={image.src} style={{ width: "700px",}} alt="imagen"/>} 
      trigger="click"
      >
      <div
        className="matApoyoLink"
        style={{ width: "auto" }}
      >
         {file.material}
      </div>
      </Popover>
  );
};

/**
 * Componente que muestra el material embebido si es tipo pdf, Se utilizó en el PEL2023.
 * @param {*} document- Material
 */
//const RenderPDF = ({ file }) => {
//  function download(file, name) {
//    let a = document.createElement("a"); //Create <a>
//    a.href = `data:application/pdf;base64,${file}`; //Image Base64 Goes here
//    a.download = `${name.trim()}.pdf`; //File name Here
//    a.click(); //Downloaded file
//  }
//  return (
//    <>
//      <div className="matTitle">Material de apoyo</div>
//      <p className="matApoyo" style={{ textAlign: "left" }}>
//        {file.material}
//      </p>
//      <embed
//        src={`data:application/pdf;base64,${file.url}`}
//        type="application/pdf"
//        width="100%"
//        height="700px"
//      />
//      <button
//        className="btnDescargar"
//        style={{ marginLeft: "0px" }}
//        onClick={(e) => download(file.url, file.material)}
//      >
//        Descargar {file.material} <Icon type="download" />
//      </button>
//    </>
//  );
//};

/**
 * Componente que muestra un link para descargar el documento si es tipo pdf.
 * @param {*} document- Material
 */
const RenderLinkPDF = ({ file, tipo }) => {
  function download(file, name) {
    let a = document.createElement("a"); //Create <a>
    a.href = `data:application/pdf;base64,${file}`; //Image Base64 Goes here
    a.download = `${name.trim()}.pdf`; //File name Here
    a.click(); //Downloaded file
  }
  return (
      <div
        className= {tipo===1 ? "guiaLink": "matApoyoLink"}
        style={{ width: "auto" }}
        onClick={(e) => download(file.url, file.material)}
      >
         {file.material}
      </div>
  );
};

/**
 * Componente que muestra un link para descargar el documento si es tipo powerPoint.
 * @param {*} document- Material
 */
const RenderLinkPowerP = ({ file}) => {
  function download(file, name) {
    let a = document.createElement("a"); //Create <a>
    a.href = `data:application/vnd.ms-powerpoint;base64,${file}`; //Image Base64 Goes here
    a.download = `${name.trim()}.pptx`; //File name Here
    a.click(); //Downloaded file
  }
  return (
    <>
      {/* <MatApoyo array={[{ material: file.material }]} /> */}
      <div
        className="matApoyoLink"
        style={{ width: "auto" }}
        type="link"
        onClick={(e) => download(file.url, file.material)}
      >
         {file.material}
      </div>
    </>
  );
};

/**
 * Componente que muestra un boton para descargar el documento si es tipo powerPoint.
 * @param {*} document- Material
 */
const RenderOther = ({ file, number, getNumber }) => {
  function download(file, name) {
    let a = document.createElement("a"); //Create <a>
    a.href = `data:application/vnd.ms-powerpoint;base64,${file}`; //Image Base64 Goes here
    a.download = `${name.trim()}.pptx`; //File name Here
    // console.log(`${name.trim()}.pptx`);
    a.click(); //Downloaded file
    /**
     * vnd.mspowerpoint
    let nameFile = `${name}.pptx`; //File name Here
    a.href = `data:application/vnd.ms-powerpoint;base64,${file}`; //Image Base64 Goes here
    a.download = nameFile.trim(); //File name Here
     */
  }
  return (
    <>
      {/* <MatApoyo array={[{ material: file.material }]} /> */}
      <div className="matTitle">Material de apoyo</div>
      <p className="matApoyo">
        {number && getNumber} {file.material}
      </p>
      <Button
        style={{ width: "auto" }}
        type="default"
        onClick={(e) => download(file.url, file.material)}
      >
        <Icon type="download" /> Descargar material
      </Button>
    </>
  );
};


